import { render, staticRenderFns } from "./AgedCard.vue?vue&type=template&id=3d080b02&scoped=true&"
import script from "./AgedCard.vue?vue&type=script&lang=js&"
export * from "./AgedCard.vue?vue&type=script&lang=js&"
import style0 from "./AgedCard.scss?vue&type=style&index=0&id=3d080b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d080b02",
  null
  
)

export default component.exports